export const createImage = (url: string) =>
    new Promise((resolve, reject) => {
        const image = new Image()
        image.addEventListener('load', () => resolve(image))
        image.addEventListener('error', (error) => reject(error))
        image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
        image.src = url
    })

async function getCroppedImg(img: any, crop: any) {

    const image = await createImage(img) as HTMLImageElement
    const croppedCanvas = document.createElement('canvas');
    croppedCanvas.width = crop.width;
    croppedCanvas.height = crop.height;
    const croppedCtx = croppedCanvas.getContext('2d');

    if (!croppedCtx) {
        return null
    }

    croppedCtx?.drawImage(
        image, 
        crop.x,
        crop.y,
        crop.width,
        crop.height,
        0,
        0,
        crop.width,
        crop.height
    );

    // RETURN AS BASE64 STRING
    return croppedCanvas.toDataURL('image/jpeg');

    // RETURN AS BLOB
    // return new Promise((resolve, reject) => {
    //     canvas.toBlob((blob) => {
    //         resolve(blob)
    //     })
    // })
}

async function url2Blob(url: string){
    return await (await fetch(url)).blob()
}

export { getCroppedImg, url2Blob };